module.exports = __webpack_public_path__ + "static/media/meals_schedule_icon.1afb3918.svg";